import { DataTable, DataTableValue } from "primereact/datatable";
import { Column } from "primereact/column";

export interface ColumnOption {
  field: string;
  header: any;
  visible: boolean;
  body?: any;
  className?: string;
  sortable?: boolean;
  rowClassName?: string;
}

interface DataTableProps<T extends DataTableValue> {
  rowData: T[]; // Dynamic rowData based on the type passed
  columns: ColumnOption[]; // Columns configuration remains consistent
  customClass?: string;
  showGridlines?: boolean;
  isMarginRight?: boolean;
}

const DataTableComponent = <T extends DataTableValue>(
  props: DataTableProps<T>
) => {
  // Custom error template (can also include icons or custom components)
  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  return (
    <div>
      <DataTable
        className={`a-table tw-text-nowrap ${
          props.isMarginRight && "tw-mr-[28px]"
        } ${props.customClass}`}
        value={props.rowData}
        sortMode="multiple"
        removableSort
        scrollable
        scrollHeight="81vh"
        paginator={false}
        showGridlines={props.showGridlines ?? false}
        tableStyle={{ minWidth: "50rem" }}
        emptyMessage={emptyMessageTemplate}
      >
        {props.columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            className={col.className || ""} // Use className if provided
            body={col.body ? col.body : undefined} // Conditionally render body template
          />
        ))}
      </DataTable>
      {/* Apply hover effect to rows */}
      <style>{`
        .a-table .p-datatable-tbody > tr:hover {
          @apply tw-bg-blue-100; /* Tailwind CSS hover background */
        }
          
        .a-table .p-datatable-thead > tr > th {
          color: #3C3D37; /* Set the header text color to black */
       }
      `}</style>
    </div>
  );
};

export default DataTableComponent;
